import React, { useEffect, useRef, useState } from 'react';

import styled from '@emotion/styled';

import DropDownModal from './DropDownModal';
import {
  ChevronDown,
  ChevronUp,
  DropDownMainContainer,
  FieldContainer,
  menuTitle
} from './DropDownStyle';
import { unselectableStyles } from '../../styles/styles';
import { mixpanelObject } from '../../utils/analytics';
import { ctaEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { isSpaceForDropDown } from '../../utils/TvShowDetailsHelper/tvShowDetailsHandler';
import {
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_DROPDOWN,
  MIXPANEL_TAB_NAME,
  MIXPANEL_ELEMENT,
  MIXPANEL_SORT
} from '../../utils/analytics/mixpanel/mixpanelConstants';

const MenuTitle = styled.div`
  ${menuTitle};
`;

interface DropDownProps {
  intervalData: string[];
  changeEventHandler: (index: number, item: string) => Promise<void>;
  defaultSelected: string | undefined;
}

const DropDown = (dropDownData: DropDownProps) => {
  const { changeEventHandler, defaultSelected } = dropDownData;
  const [selectedItem, setSelectedItem] = useState<string>(
    defaultSelected || dropDownData?.intervalData?.[0]
  );
  const [showItem, setShowItem] = useState(false);
  const [positionDownwards, setPositionDownwards] = useState(false);
  const findDropdownIndex = dropDownData?.intervalData.findIndex(
    (item) => item === selectedItem
  );
  const defaultDropdownIndex = findDropdownIndex < 0 ? 0 : findDropdownIndex;
  const [selectedDropDownIndex, setSelectedDropDownIndex] =
    useState<number>(defaultDropdownIndex);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const positionDirection = isSpaceForDropDown(dropdownRef, 172);
      setPositionDownwards(positionDirection);
    };

    // subscripting to the event
    if (showItem === true) {
      window.addEventListener('scroll', handleScroll);
    } else if (showItem === false) {
      window.removeEventListener('scroll', handleScroll);
    }
    // unsubscriping to the event on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showItem]);

  // dropDown implementation
  const handleOnClick = (): void => {
    setShowItem((prevState: boolean) => !prevState);
    const positionDirection = isSpaceForDropDown(dropdownRef, 172);
    setPositionDownwards(positionDirection);
  };

  const showDropdownModal = () => {
    setShowItem(true);
    mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_DROPDOWN);
    mixpanelObject.setProperty(MIXPANEL_TAB_NAME, 'zee5originals_detail');
    mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_SORT);
    ctaEvent(true);
  };
  const closeDropdownModal = () => {
    setShowItem(false);
  };

  // on click of the episode interval
  const handleOptionClick = (item: string, index: number) => {
    changeEventHandler(index + 1, item);
    setSelectedDropDownIndex(index);
    setShowItem((prevState: boolean) => !prevState);
    setSelectedItem(item);
  };

  useEffect(() => {
    if (defaultSelected && defaultSelected !== selectedItem) {
      const index =
        dropDownData?.intervalData.findIndex(
          (item) => item === defaultSelected
        ) || -1;
      if (index >= 0) {
        setSelectedItem(defaultSelected);
        setSelectedDropDownIndex(index);
      }
    }
  }, [defaultSelected]);

  return (
    <>
      {selectedItem && (
        <DropDownMainContainer
          data-testid="dropDown-container"
          css={unselectableStyles}
          onMouseLeave={closeDropdownModal}
          ref={dropdownRef}
          page={'consumption'}>
          <FieldContainer>
            <MenuTitle
              data-testid="dropDown-menu-title"
              onMouseEnter={showDropdownModal}
              onClick={handleOnClick}>
              <span>{selectedItem}</span>
              <div css={showItem ? ChevronDown : ChevronUp} />
            </MenuTitle>
          </FieldContainer>
          {showItem && (
            <DropDownModal
              intervalData={dropDownData?.intervalData}
              handleOptionClick={handleOptionClick}
              positionDownwards={positionDownwards}
              selectedDropDownIndex={selectedDropDownIndex}
            />
          )}
        </DropDownMainContainer>
      )}
    </>
  );
};

export default DropDown;
